import { useEffect } from 'react';

import { usePaginatedFilter } from '../../hooks/usePaginatedFilter';
import PaginationTable from './PaginationTable';

/**
 * Pagina tablas de detalle cuyos renglones ya forman parte del documento cargado.
 * @param {Object} props
 * @param {Array<Object>} props.rows Conjunto completo de renglones filtrados y ordenados.
 * @param {Function} props.children Renderiza la tabla con las filas visibles y su índice inicial.
 * @param {string} [props.resetKey] Documento, filtro u orden que vuelve a la primera página.
 * @returns {JSX.Element}
 */
const ClientPaginatedTable = ({ rows = [], children, resetKey }) => {
  const pagination = usePaginatedFilter({ data: rows });
  const { setPage } = pagination;

  useEffect(() => {
    setPage(1);
  }, [resetKey, setPage]);

  return (
    <>
      {children(pagination.data, (pagination.page - 1) * pagination.rowsPerPage)}
      {pagination.totalCount > 0 && (
        <PaginationTable
          page={pagination.page}
          totalPages={pagination.totalPages}
          totalCount={pagination.totalCount}
          rowsPerPage={pagination.rowsPerPage}
          onPageChange={pagination.handlePageChange}
          onRowsPerPageChange={pagination.handleRowsPerPageChange}
        />
      )}
    </>
  );
};

export default ClientPaginatedTable;
